<template>
  <form id="frm_action" :key="componentKey">
    <!-- <div class="row p-col-12 group-button-detail-top">
      <Button
        v-for="lad in list_action_detail"
        :key="lad.code_change"
        :label="lad.action"
        class="style-button-common  mt-lg-0 mt-2"
        :class="lad.class_button"
        @click="click_change_status(lad.code_change)"
      />
    </div> -->

    <div class="p-formgrid">
      <div class="col-6">
        <div class="p-card-field" style="margin-top: 8px; margin-bottom: 8px">
          <p style="padding-left: 8px">Are you sure you want to complete this booking? The weekly fee won’t be auto-charged. Hera Trading and the
            renter will need to complete all payments.</p>
          <!-- <label class="p-col-fixed txt-right style_title_group txt_style_lable">
            </label> -->
          <!--          <div class="p-col">
          </div>-->
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right txt_style_lable"
          >Cost</label
          >
          <div class="p-col">
            <InputText
                maxlength="50"
                id="contract_id"
                type="text"
                class=""
                v-model="obj_data.description"
                placeholder="Input"
            />
          </div>
        </div>
        <div class="p-card-field">
          <label class="p-col-fixed txt-right  txt_style_lable"
          >Amount</label
          >
          <div class="p-col">
            <div class="p-inputgroup">
              <InputNumber
                  id="rent_pay_price_per_week"
                  placeholder="Input"
                  v-model="obj_data.amount"
                  mode="decimal"
                  :minFractionDigits="2"
                  @keyup="change_price_common"
              />
              <span class="p-inputgroup-addon">$</span>
            </div>
          </div>
        </div>
        <div class="p-card-field">
<!--          <label class="p-col-fixed txt-right txt-required txt_style_lable"-->
<!--          >Price per week</label-->
<!--          >-->
          <div class="p-col">
            <Button
                type="button"
                :icon="'pi pi-plus'"
                :class="'p-button-add'"
                style="margin: 2px"
                 @click="save_item_list_other_cost"
            ></Button>
<!--            <div class="p-inputgroup">-->
<!--              <InputNumber-->
<!--                  id="rent_pay_price_per_week"-->
<!--                  placeholder="Input"-->
<!--                  v-model="obj_data.rent_pay_price_per_week"-->
<!--                  mode="decimal"-->
<!--                  :minFractionDigits="2"-->
<!--                  @keyup="change_price_common"-->
<!--              />-->
<!--              <span class="p-inputgroup-addon">$</span>-->
<!--            </div>-->
          </div>
        </div>
        </div>
      <div class="col-12">
<!--        <div class="p-card-field">-->
<!--          <div class="p-col">-->
<!--            <BaseDatatable v-if="dataModelType" :key="componentKeyType" :tableData="listDataType" :model="dataModelType"-->
<!--                           :actions="getRowActions()" v-on:action-click="onActionClicked"></BaseDatatable>-->
<!--          </div>-->
<!--        </div>-->
      <!--  //Other cost -->
      <div class="p-card-field">
         <div class="p-col">
           <BaseDatatableOtherCost
               v-if="dataModelOtherCost"
               :key="componentKeyOtherCost"
               :model="dataModelOtherCost"
               :actions="getRowActionsOtherCost()"
               :tableData="listDataOtherCost"
                v-on:action-click="onActionClickedOtherCost"
           >
           </BaseDatatableOtherCost>
          </div>
      </div>

           <!-- :actions="getRowActionsOtherCost()"
               v-on:action-click="onActionClickedOtherCost" -->
      </div>
        <div class="col-6">
        <div
            class="p-card-field"
            :class="
            !$commonFuction.isEmpty(obj_data.rent_voucher_id)
              ? 'clear_icon_select'
              : ''
          "
            v-if="core_display_view('rent_voucher_id')"
        >
          <label class="p-col-fixed txt-right txt_style_lable">Voucher</label>
          <div class="p-col">
            <!-- @search="SearchVoucher"  @input="change_list_voucher"  -->
            <v-select
                :key="key_voucher"
                :clearable="false"
                class=""
                placeholder="Choose"
                v-model="obj_data.rent_voucher_id"
                :options="list_voucher"
                :reduce="(item) => item.id"
                label="code"
                @input="change_list_voucher"
            >
              <span slot="no-options" @click="$refs.select.open = false">
                Empty data
              </span>
            </v-select>
            <input class="input_tmp_validator" id="tmp_rent_voucher_id"/>
          </div>
        </div>

        <div
            class="p-card-field div_check"
            v-if="core_display_view('is_pay_booking_fee')"
        >
          <div class="p-col checkbox">
            <Checkbox v-model="obj_data.is_pay_booking_fee" :binary="true"/>
            <label class="p-col-fixed txt-right text">Booking fee paid</label>
          </div>
        </div>

        <div class="p-card-field" style="margin-top: 8px; margin-bottom: 8px">
          <label class="p-col-fixed txt-right style_title_group txt_style_lable"
          >FINAL PAYMENT</label
          >
          <!--          <div class="p-col">
          </div>-->
        </div>

        <div class="p-card-field style-box-payment" style="margin-top: 8px; margin-bottom: 8px">
          <div class="box-payment">
            <div class="payment-item">
              <span class="title">Bond fee</span>
              <span class="price">{{obj_data.rent_pay_bond_fee_filnal}}</span>
            </div>
            <div class="payment-item" v-if="this.obj_data.total_bill_owe>0">
              <span class="title">Owe (*{{this.obj_data.total_bill_owe}} bills)</span>
              <span class="price">{{obj_data.total_owe_filnal}}</span>
            </div>
            <div class="payment-item" v-if="this.obj_data.total_bill_other_cost">
              <span class="title">Other cost ({{this.obj_data.total_bill_other_cost}})</span>
              <span class="price">{{obj_data.total_other_cost_filnal}}</span>
            </div>
            <div class="line_horizontal"></div>
            <div class="payment-item">
              <span class="title">Refund bond fee (inc GST)</span>
              <span class="price" style="color: #F5564E;font: normal normal bold 16px/19px Segoe UI;">{{obj_data.refund_bond_fee}}</span>
            </div>
            <div class="payment-item">
              <span class="title">Renter’s final payment</span>
              <span class="price"  style="color: #00973C;font: normal normal bold 16px/19px Segoe UI;">{{obj_data.renter_final_payment}}</span>
            </div>
            <div class="payment-item"  >
              <span class="title">{{obj_data.text_bill_owe}}</span>
              <!-- <span class="price">{{obj_data.rent_pay_bond_fee_filnal}}</span> -->
            </div>
          </div>


        </div>


      </div>

      
      <Toolbar class="fixed-bottom-toolbar div-button">
        <template slot="right">
          <Button
              :label="$constants.TEXT_BUTTON.BACK"
              @click="backToList()"
              class="p-button-outlined"
              id="back"
          />
          <Button
              :label="'Completed'"
               @click="saveData($constants.TYPE_ACTION.COMPLETED_PAYMENT)"
              class="main-style-button"
          />
          <Button
              v-if="show_request ==true"
              :label="'Payment request'"
              @click="saveData($constants.TYPE_ACTION.PAYMENT_REQUEST)"
              class="main-style-button"
          />
        </template>
      </Toolbar>
    </div>

<Dialog header="Delete" :visible.sync="showDeleteDialog" :contentStyle="{ overflow: 'visible' }" :modal="true">
          Are you want to delete this Other Cost ?
          <template #footer>

            <Button label="Cancel" @click="showDeleteDialog = false" icon="pi pi-times" class="p-button-warning" />
            <Button label="Confirm" @click="deleteDataOtherCost()" icon="pi pi-check"
                    class="p-button-danger  btn-confirm-delete-dialog" />
          </template>
        </Dialog>

  </form>
</template>
<script>
import moment from "moment-timezone";
import DataServices from "@/core/DataServices";
//import Common from "../../../core/Common";
import ApiRepository from "@/core/ApiRepository";
//import BaseDatatable from './list_need_to_pay';
import BaseDatatableOtherCost from './list_other_cost';

export default {
  components: {
   // BaseDatatable,
    BaseDatatableOtherCost
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      Deselect: {
        render: (createElement) => createElement("span", "❌"),
      },

      listStatus: [
        {id: "BOOKED_RENT", name: "Booked", style: "color:  #000000;"},
        {id: "RENTING_RENT", name: "Renting", style: "color:  #000000;"},
        {id: "COMPLETED_RENT", name: "Completed", style: "color:  #000000;"},
        {id: "CANCEL_RENT", name: "Cancelled", style: "color:  #000000;"},
        {id: "CLOSING_RENT", name: "Closing", style: "color:  #000000;"},
      ],

      listUser: [],
      listUserAll: [],

      key_state: 0,
      key_vehicle_category: 0,
      key_term: 0,
      key_voucher: 0,
      key_rent_pick_up_date: 0,
      key_car_for_rent: 0,
      key_car_for_rent_event: 0,
      key_car_for_rent_color_event: 0,

      listCountry: [],
      listCountryAll: [],
      mapCountryAll: {},

      list_available_for_rent: [],
      list_available_for_rent_all: [],
      map_available_for_rent_all: {},

      list_vehicle_category_id: [],
      list_vehicle_category_id_all: [],
      map_vehicle_category_id_all: {},

      list_term_id: [],
      list_term_id_all: [],
      map_term_id_all: {},


      list_term_id_event: [],
      list_term_id_all_event: [],
      map_term_id_all_event: {},

      list_showroom_id: [],
      list_showroom_id_all: [],
      map_showroom_id_all: {},
      //rent_car_for_rent_id
      list_car_for_rent_id: [],
      list_car_for_rent_id_all: [],
      map_car_for_rent_id_all: {},

      list_car_for_rent_id_event: [],
      list_car_for_rent_id_all_event: [],
      map_car_for_rent_id_all_event: {},

      // dataModelType: null,
      // componentKeyType: 1,
      // listDataType: [],

      dataModelNeedToPay: null,
      componentKeyNeedToPay: 1,
      listDataNeedToPay: [],
      show_request :false,

      listState: [],
      listStateAll: [],

      list_voucher: [],
      list_voucher_all: [],
      map_voucher_all: {},

      showDeleteDialog: false,
      showConfirmDialog: false,
      showCancelDialog: false,
      showChangeCarDialog: false,
      //Reset late fee
      showResetLateFeeDialog: false,
      //Renew contract for this booking
      showRenewContractDialog: false,

      list_id_file_delete: [],

      passwordType: "password",
      passwordReType: "password",

      file_product: null,
      list_file_product: [],
      list_id_file_delete_product: [],
      dataFamilyDisplay: false,
      componentDataFamily: 1,
      dataFamily: {},
      dataModelUserFamily: null,
      componentKeyUserFamily: 1,
      listDataUserFamily: [],

      dataModelProperty: null,
      componentKeyProperty: 1,
      listDataProperty: [],

      // dataModelType: null,
      // componentKeyType: 1,
      // listDataType: [],
      //Other cost
       dataModelOtherCost: null,
      componentKeyOtherCost: 1,
      listDataOtherCost: [],



      obj_data: {
        filename: "",
        filename_after: "",
        prefix_phone: "",
      },
      comFilename: 1,
      comFilenameAfter: 1,
      list_phone_code: [
        {
          prefix_phone: "+84",
        },
        {
          prefix_phone: "+45",
        },
      ],
      dataBookingRound: [],
      selProperty: null,
      listProperty: [],
      listPropertyAll: [],
      listDocsCate: [],
      listDocsCateAll: [],
      list_action_detail: [
        // { code_change: "CANCEL_RENT", action: "Cancel" },
        // { code_change: "RENTING_RENT", action: "Confirm pick-up" },
        // { code_change: "CHANGE_CAR", action: "Change the car" },
        // { code_change: "RESET_LATE_FEE", action: "Reset late fee" },
        // { code_change: "RENEW_CONTRACT", action: "Renew" },

        // { code_change: "delete", action: "Delete" },
      ],
      from_to: null,
      address: null,
      start_booking_date: null,
      end_booking_date: null,
      partArr: [],
      time_zone_local: moment.tz.guess(true),
      componentKey: 0,
      list_file: [],
      list_file_after: [],
      list_id_file_delete_after: [],

      is_change_price: false,

      list_identification_type: [
        {
          id: 1,
          name: "Driver's license",
        },
        {
          id: 2,
          name: "Internation license",
        },
        {
          id: 3,
          name: "Passport",
        },
        {
          id: 4,
          name: "I will provide it upon pickup",
        },
      ],

      maxFileSize: 2097152 * 50, //100MB  2MB   /*104857600, // 100MB*/
    };
  },
  watch: {
    "listDataOtherCost": function () {
      //newVal, oldVal
      console.log( "loadCallFee");
      this.loadCallFee();
    }
    // },
    // "obj_data.is_allow_car_category": function () {
    //   //newVal, oldVal

    //   this.getListCarForRent();
    // },
    // "obj_data.rent_available_id": function () {
    //   //newVal, oldVal
    //   this.generate_data();
    // },
    // "obj_data.rent_car_for_rent_id": function () {
    //   //newVal, oldVal
    //   console.log(
    //       "this.obj_data.rent_car_for_rent_id:",
    //       this.obj_data.rent_car_for_rent_id
    //   );
    //   this.generate_data();
    // },
    // "obj_data.rent_term_id_root": function () {
    //   //newVal, oldVal
    //   console.log(
    //       "this.obj_data.rent_term_id_root:",
    //       this.obj_data.rent_term_id_root
    //   );
    //   console.log(
    //       "this.list_term_id_all_event:",
    //       this.map_term_id_all_event[this.obj_data.rent_term_id_root]
    //   );
    //   if (!this.$commonFuction.isEmpty(this.map_term_id_all_event[this.obj_data.rent_term_id_root])) {
    //     var item_term = this.map_term_id_all_event[this.obj_data.rent_term_id_root];
    //     this.obj_data.rent_pay_price_per_week_new = this.map_term_id_all_event[this.obj_data.rent_term_id_root].price_per_unit;
    //     console.log("this.obj_data.rent_valid_until_root", this.obj_data.rent_valid_until_root)
    //     // var  startDate =  moment.tz(this.$constants.DB_TIMEZONE, this.obj_data.rent_valid_until_root);
    //     // console.log("startDate:",startDate);
    //     var day_term = this.$CoreService.getDurationInDays(item_term.unit_duration, item_term.duration);
    //     console.log("day_term:", day_term);
    //     var date_end_term = moment.tz(this.obj_data.rent_valid_until_root, this.$constants.DB_TIMEZONE).add(day_term, 'days').format('YYYY-MM-DD HH:mm');
    //     console.log("date_end_term:", date_end_term);
    //     this.obj_data.rent_valid_until_new = new Date(
    //         date_end_term
    //     );
    //     console.log(" this.obj_data.rent_valid_until_new", this.obj_data.rent_valid_until_new);
    //   }
    // },
    // "obj_data.rent_car_for_rent_id_event": function () {
    //   //newVal, oldVal
    //   console.log(
    //       "chyang test"
    //   );
    //   if (!this.$commonFuction.isEmpty(this.obj_data.rent_car_for_rent_id_event)) {
    //     console.log(
    //         "this.obj_data.object:",
    //         this.map_car_for_rent_id_all_event[this.obj_data.rent_car_for_rent_id_event]
    //     );
    //     this.obj_data.color_car_forent_event =
    //         this.map_car_for_rent_id_all_event[
    //             this.obj_data.rent_car_for_rent_id_event
    //             ]?.color;
    //   } else {
    //     this.obj_data.color_car_forent_event = null;
    //   }
    // },
  },
  async mounted() {
    /*await this.getListProperty();
    await this.getListDocsCate();*/
    console.log("this.modethis.modethis.mode:", this.mode);
    console.log("this.model:", this.model);
    // await this.getList_available_for_rent(); //hàm này đồng bộ để lấy data hiển thị post_id
    // this.getListVehicleCategory();
    // this.getList_showroom();
    // this.getListUser();
    //this.getListCountry();
     this.$set(this, 'listDataOtherCost', []);
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.obj_data = this.model;
      this.obj_data.filename = this.model?.item_avatar?.file_name ?? "";
      if (!this.$commonFuction.isEmpty(this.model?.item_avatar)) {
        let url = this.model?.item_avatar?.url;
        let obj = {
          name: this.obj_data.filename,
          file: "",
          objectURL: url,
          type: "old_edit",
        }; //type:'old_edit' nếu gặp type này ko update avatar
        this.list_file.push(obj);
      }

     // this.loadButtonAction()
      //
      this.obj_data.filename_after =
          this.model?.item_avatar_after?.file_name ?? "";
      if (!this.$commonFuction.isEmpty(this.model?.item_avatar_after)) {
        let url = this.model?.item_avatar_after?.url;
        let obj = {
          name: this.obj_data.filename_after,
          file: "",
          objectURL: url,
          type: "old_edit",
        }; //type:'old_edit' nếu gặp type này ko update avatar
        this.list_file_after.push(obj);
      }
      this.obj_data.rent_car_for_rent_id = this.model.rent_car_for_rent_id
          ? this.model.rent_car_for_rent_id
          : null;
      //await this.getListTerm(this.obj_data.rent_vehicle_category_id);
      //await this.getListCarForRent();
     // this.generate_data();
      // if (!this.$commonFuction.isEmpty(this.model.country_id)){
      //   this.getListState(this.model.country_id);
      // }
      // var user_customer_care = this.model.user_customer_care
      // if (user_customer_care.length > 0){
      //   if (!this.$commonFuction.isEmpty(user_customer_care[0]["user_customer_care"])){
      //     if (!this.$commonFuction.isEmpty(user_customer_care[0]["user_customer_care"]["sale_person_id"])){
      //       this.obj_data.sale_person_id =  user_customer_care[0]["user_customer_care"]["sale_person_id"]
      //     }
      //   }
      // }
      // if (!this.$commonFuction.isEmpty(this.model.birthday)){
      //   this.obj_data.birthday =new Date(this.model.birthday);
      //   console.log("this.obj_data.birthday:",this.obj_data.birthday)
      // }
      if (!this.$commonFuction.isEmpty(this.model.rent_pick_up_date)) {
        this.obj_data.rent_pick_up_date = new Date(
            this.model.rent_pick_up_date
        );
      }
      if (!this.$commonFuction.isEmpty(this.model.rent_valid_until)) {
        this.obj_data.rent_valid_until_root = this.model.rent_valid_until;
        this.obj_data.rent_valid_until = new Date(this.model.rent_valid_until);
      }
      if (!this.$commonFuction.isEmpty(this.model.created_at)) {
        this.obj_data.created_at = new Date(this.model.created_at);
      }

      this.obj_data.rent_booking_fee = parseFloat(this.model.rent_booking_fee);
      this.obj_data.rent_pay_price_per_week = parseFloat(
          this.model.rent_pay_price_per_week
      );
      this.obj_data.rent_pay_bond_fee = parseFloat(
          this.model.rent_pay_bond_fee
      );
      this.obj_data.rent_late_fee_threshold = parseFloat(
          this.model.rent_late_fee_threshold
      );
      this.obj_data.rent_late_fee_per_day = parseFloat(
          this.model.rent_late_fee_per_day
      );

      var total_payment_pick_up = this.obj_data.rent_pay_price_per_week + this.obj_data.rent_pay_bond_fee - this.obj_data.rent_booking_fee;


      this.obj_data.total_payment_pick_up = this.$commonFuction.numberFormat(total_payment_pick_up, 2, '.', ',');
      this.obj_data.rent_pay_price_per_week_root = this.$commonFuction.numberFormat(this.obj_data.rent_pay_price_per_week, 2, '.', ',');
      this.obj_data.rent_pay_bond_fee_root = this.$commonFuction.numberFormat(this.obj_data.rent_pay_bond_fee, 2, '.', ',');
      this.obj_data.rent_booking_fee_root = this.$commonFuction.numberFormat(this.obj_data.rent_booking_fee, 2, '.', ',');

      this.obj_data.rent_late_fee_threshold_root = this.obj_data.rent_late_fee_threshold;
      this.obj_data.rent_late_fee_per_day_root = this.obj_data.rent_late_fee_per_day;


      this.obj_data.rent_vehicle_category_name_root = this.obj_data.rent_vehicle_category_name;
      this.obj_data.rent_vehicle_category_id_root = this.obj_data.rent_vehicle_category_id;


      this.componentKey++;

      // this.dataModelType = DataServices.getModel('role_admin_property');
      // console.log('this.dataModelType:', this.dataModelType)
      // this.componentKeyType++;

      // this.componentKey++;
      // this.dataModelNeedToPay = DataServices.getModel("payment_history_order");
      // console.log("this.dataModelNeedToPay:", this.dataModelNeedToPay);
      // this.componentKeyNeedToPay++;
      //this.setDataPopup()

      //dataModelOtherCost
      this.dataModelOtherCost = DataServices.getModel("othercost");
      console.log("this.dataModelOtherCost:", this.dataModelOtherCost);
      this.componentKeyOtherCost++;
    } else {
      //thêm mới
      this.obj_data = {
        /* fullname: "Tuyen",
        email: "asdasdaskdjkask@gmail.com",
        prefix_phone: "+45",
        phone: "234434535",*/
        /*
        password: "123456",
        re_password: "123456",*/

        //default data

        booking_status: "BOOKED_RENT",
        active: true,
        ordinal: 1,
      };
      this.listStatus = [
        {id: "BOOKED_RENT", name: "Booked", style: "color:  #000000;"},
      ];

      var late_fee_threshold = await this.$CoreService.getSetting(
          "LATE_FEE_THRESHOLD"
      );
      console.log("late_fee_threshold:", late_fee_threshold);
      this.obj_data.rent_late_fee_threshold = !this.$commonFuction.isEmpty(
          late_fee_threshold.value
      )
          ? parseFloat(late_fee_threshold.value)
          : 0;
      var late_fee_per_day = await this.$CoreService.getSetting(
          "LATE_FEE_PER_DAY"
      );
      console.log("late_fee_per_day:", late_fee_per_day);
      this.obj_data.rent_late_fee_per_day = !this.$commonFuction.isEmpty(
          late_fee_per_day.value
      )
          ? parseFloat(late_fee_per_day.value)
          : 0;
      // this.dataModelUserFamily = DataServices.getModel('user_family');
      // this.componentKeyUserFamily++;

      this.componentKey++;
    }
  },
  methods: {
    async loadCallFee() {
      var rent_pay_bond_fee = (this.obj_data.rent_pay_bond_fee) ? parseFloat(this.obj_data.rent_pay_bond_fee) : 0;
      var rent_list_owe = this.obj_data?.rent_list_owe ?? [];
      var rent_list_other_cost = this.obj_data?.rent_list_other_cost ?? [];
      var total_owe = 0;
      var total_other_cost = 0;
      var total_bill_owe = 0;
      var total_bill_other_cost = 0;
      var arr_text_bill_owe = [];
      for (let i = 0; i < rent_list_owe.length; i++) {
            var itemData = rent_list_owe[i];
           var amount_owe = (!this.$commonFuction.isEmpty(itemData?.amount)) ? parseFloat(itemData.amount):0;
            total_owe += amount_owe;
            total_bill_owe ++;
            arr_text_bill_owe.push(itemData?.code);
        }
        if (arr_text_bill_owe.length > 0){
            this.obj_data.text_bill_owe = `(*) `+arr_text_bill_owe.join('; ');
        }
        for (let h = 0; h < rent_list_other_cost.length; h++) {
            var itemData1 = rent_list_other_cost[h];
            var amount_cost = (!this.$commonFuction.isEmpty(itemData1?.amount)) ? parseFloat(itemData1.amount):0;
            total_other_cost += amount_cost;
            total_bill_other_cost++;
        }
        //listDataOtherCost
        for (let j = 0; j < this.listDataOtherCost.length; j++) {
            var itemData2 = this.listDataOtherCost[j];
            var amount_cost2 = (!this.$commonFuction.isEmpty(itemData2?.amount)) ? parseFloat(itemData2.amount):0;
            total_other_cost += amount_cost2;
             total_bill_other_cost++;
        }
        this.obj_data.total_bill_owe = total_bill_owe;
        this.obj_data.total_bill_other_cost = total_bill_other_cost;
        this.obj_data.rent_pay_bond_fee_filnal ='-$'+((rent_pay_bond_fee ) ? this.$commonFuction.numberFormat(rent_pay_bond_fee, 2, '.', ','):'0.00') ;
        this.obj_data.total_owe_filnal ='$'+((total_owe ) ? this.$commonFuction.numberFormat(total_owe, 2, '.', ','):'0.00') ;
        this.obj_data.total_other_cost_filnal ='$'+((total_other_cost ) ? this.$commonFuction.numberFormat(total_other_cost, 2, '.', ','):'0.00') ;
        var total_final_payment = -rent_pay_bond_fee +total_owe+total_other_cost;
        var renter_final_payment = 0;
        var refund_bond_fee = 0;
        if(total_final_payment >0){
          renter_final_payment = total_final_payment;
          this.show_request = true;
        }else{
          refund_bond_fee = total_final_payment;
          this.show_request = false;
        }
        if(this.obj_data.rent_is_request_final_payment ==true){
            this.show_request = false;
        }
        this.obj_data.renter_final_payment ='$'+((renter_final_payment ) ? this.$commonFuction.numberFormat(renter_final_payment, 2, '.', ','):'0.00') ;
        this.obj_data.refund_bond_fee ='-$'+((refund_bond_fee ) ? this.$commonFuction.numberFormat(Math.abs(refund_bond_fee), 2, '.', ','):'0.00') ;
    },
  async save_item_list_other_cost() {
      console.log("this.obj_data:", this.obj_data.description );
      if (this.$commonFuction.isEmpty(this.obj_data.description)) {
        alert("Please enter the cost name");
        return;
      }
        console.log("this.obj_data.price_cost:", this.obj_data.amount);
      if (this.$commonFuction.isEmpty(this.obj_data.amount)) {
        alert("Please enter the price");
        return;
      }
      //check input price >0
      if (this.obj_data.amount <= 0) {
        alert("Please enter the price > 0");
        return;
      }
      
       var itemObject = {
          description: this.obj_data.description,
          amount: this.obj_data.amount,
          text_amount:'$'+ this.$commonFuction.numberFormat(this.obj_data.amount, 2, '.', ','),
        };
      //   this.listDataType.push(itemObject);
      this.obj_data.property_ids = [];
      // this.loadTableType();
      this.listDataOtherCost.push(itemObject);
      this.loadTableOtherCost();
      //clear
      this.obj_data.description = "";
      this.obj_data.amount = null;
    },
    async loadTableOtherCost() {
      var stt = 0;
      var listDataType = this.listDataOtherCost;
      //this.mapServicePrice = {};
      for (let i = 0; i < listDataType.length; i++) {
        stt++;
        //var itemData = listDataType[i];
        //var id = itemData?.id ?? null;
        listDataType[i].stt = stt;
        listDataType[i].index = i;
        //this.mapServicePrice[id] = itemData;
      }
     // this.listDataOtherCost = listDataType
      this.$set(this, 'listDataOtherCost', listDataType);
      console.log(" this.listDataOtherCost:", this.listDataOtherCost)
      this.dataModelOtherCost = DataServices.getModel('othercost');
     // this.dataModelOtherCost.processData(listDataType)
      this.componentKeyOtherCost++;
    },
    async deleteDataOtherCost() {
      this.showDeleteDialog = false;
      var list_data = []
      for (let i = 0; i < this.listDataOtherCost.length; i++) {
        var item_data = this.listDataOtherCost[i];
        console.log("this.deleteId:", this.deleteId);
        console.log("item_data.index:", item_data.index);
        if (this.deleteId != item_data.index) {
          list_data.push(item_data);
        }
      }
      this.listDataOtherCost = list_data;
      this.loadTableOtherCost()
    },
    getRowActionsOtherCost() {
      var actions = {}
      //var that = this;
      //actions.header = {name: 'add', icon: 'plus', path: `list-othercost/add`};
      actions.rows = function () {//rowData
        var buttons = {}
        //buttons.view = {name: 'view', icon: 'eye', key: 'id', path: `list-othercost/view/`};
      //  buttons.edit = {name: 'edit', icon: 'pencil', key: 'id', path: `list-othercost/edit/`};
        buttons.delete = {name: 'delete', icon: 'trash', key: 'id'}
        return buttons
      }
      return actions
    },
    //delete thui
    
    async onActionClickedOtherCost(payload) {

      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'delete':
          localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
          this.page_transaction = pageTransaction;
          console.log(data.data);
          this.deleteId = data.data['index']
          // this.countRelationship = (data.data.users_club_expiration_aggregate.aggregate.count + data.data.users_setting_sports_aggregate.aggregate.count + data.data.users_stripe_aggregate.aggregate.count + data.data.bookings_aggregate.aggregate.count);
          this.deleteName = data.data.name
          this.showDeleteDialog = true
          break
      }
    },
    async confirmDataPopup(code) {
      // var code_order = this.obj_data.code
      // var prefix_code = code_order.substring(0, 2);
      var obj_res = {};
      var dataRequest = {};
      switch (code) {
          // case this.$constants.STATUS_ORDER.EDIT:
          //   var url_edit = `/admin/list-order/edit/${this.model.id}`
          //   if (!this.$commonFuction.isEmpty(this.$route.query)){
          //     if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
          //       url_edit +=`?page_transaction=${this.$route.query.page_transaction}`
          //     }
          //   }
          //   console.log("url_editurl_edit:",url_edit)
          //   window.location.href = url_edit
          //   break;
        case 'CONFIRM_PICK_UP':
          //check chọn xe License plate number
          if (this.$commonFuction.isEmpty(this.obj_data.rent_car_for_rent_id_event)) {
            alert("Please choose a car");
            return;
          }
          dataRequest = {
            obj_data: this.obj_data,
          }
          this.$commonFuction.is_loading(true);
          obj_res = await this.$CoreService.sendApi('/api_admin/order/confirm_pickup_admin', dataRequest);

          if (obj_res.is_success == true) {
            alert(this.$constants.MSG_TEXT.CONFIRMED_SUCCESSFULLY);
            this.showConfirmDialog = false;
            this.reload_page_vue()
          } else {
            this.$commonFuction.is_loading(false);
            alert(obj_res.message_text);
          }
          break;
        case 'CANCEL_RENT':
          dataRequest = {
            obj_data: this.obj_data,
          }
          this.$commonFuction.is_loading(true);
          obj_res = await this.$CoreService.sendApi('/api_admin/order/cancel_order', dataRequest);

          if (obj_res.is_success == true) {
            alert(this.$constants.MSG_TEXT.CONFIRMED_SUCCESSFULLY);
            this.showConfirmDialog = false;
            this.reload_page_vue()
          } else {
            this.$commonFuction.is_loading(false);
            alert(obj_res.message_text);
          }
          break;
        case 'EDIT':
          window.location.href = `/admin/list-rental_order/edit/${this.model.id}`
          break;


        case 'CHANGE_CAR':
          if (this.$commonFuction.isEmpty(this.obj_data.rent_car_for_rent_id_event)) {
            alert("Please choose a car");
            return;
          }
          dataRequest = {
            obj_data: this.obj_data,
          }
          this.$commonFuction.is_loading(true);
          obj_res = await this.$CoreService.sendApi('/api_admin/order/change_car', dataRequest);

          if (obj_res.is_success == true) {
            alert(this.$constants.MSG_TEXT.CONFIRMED_SUCCESSFULLY);
            this.showConfirmDialog = false;
            this.reload_page_vue()
            // window.location.reload();
          } else {
            this.$commonFuction.is_loading(false);
            alert(obj_res.message_text);
          }
          break;
        case 'RESET_LATE_FEE':
          dataRequest = {
            obj_data: this.obj_data,
          }
          this.$commonFuction.is_loading(true);
          obj_res = await this.$CoreService.sendApi('/api_admin/order/reset_late_fee', dataRequest);

          if (obj_res.is_success == true) {
            alert(this.$constants.MSG_TEXT.CONFIRMED_SUCCESSFULLY);
            this.showConfirmDialog = false;
            this.reload_page_vue()
            // window.location.reload();
          } else {
            this.$commonFuction.is_loading(false);
            alert(obj_res.message_text);
          }
          break;
        case 'RENEW_CONTRACT':
          dataRequest = {
            obj_data: this.obj_data,
          }
          this.$commonFuction.is_loading(true);
          obj_res = await this.$CoreService.sendApi('/api_admin/order/renew_contract', dataRequest);

          if (obj_res.is_success == true) {
            alert(this.$constants.MSG_TEXT.CONFIRMED_SUCCESSFULLY);
            this.showConfirmDialog = false;
            this.reload_page_vue()
            // window.location.reload();
          } else {
            this.$commonFuction.is_loading(false);
            alert(obj_res.message_text);
          }
          break;

        default:
          //text = "Looking forward to the Weekend";
      }
    },
    async reload_page_vue() {
      window.location.reload();

    },
    async setDataPopup() {
      this.$set(this.obj_data, 'is_allow_car_category_event', this.obj_data.is_allow_car_category);
      await this.getListCarForRentEvent();
      this.$set(this.obj_data, 'rent_car_for_rent_id_event', this.obj_data.rent_car_for_rent_id);
      await this.getListTermEvent(this.obj_data.rent_vehicle_category_id);
      this.$set(this.obj_data, 'rent_term_id_root', this.obj_data.rent_term_id);
    },
    //Trạng thái rent: BOOKED_RENT,RENTING_RENT,COMPLETED_RENT,CANCEL_RENT
    //main-style-button style_btn_grey
    loadButtonAction() {
      var map_action = {
        BOOKED_RENT: [
          {code_change: "CANCEL_RENT", action: "Cancel", class_button: 'style_btn_grey'},
          {code_change: "EDIT", action: "Edit", class_button: 'main-style-button'},
          {code_change: "CONFIRM_PICK_UP", action: "Confirm pick-up", class_button: 'main-style-button'}
        ],
        RENTING_RENT: [
          {code_change: "CHANGE_CAR", action: "Change the car", class_button: 'style_btn_grey'},
          {code_change: "RESET_LATE_FEE", action: "Reset late fee", class_button: 'style_btn_grey'},
          {code_change: "RENEW_CONTRACT", action: "Renew", class_button: 'main-style-button'},
          {code_change: "COMPLETE", action: "Complete", class_button: 'main-style-button'},
        ]
      }
      console.log('this.obj_data.booking_status:', this.obj_data.booking_status)
      console.log('this.obj_data.dddddddddddddd:', map_action[this.obj_data.booking_status])

      if (map_action[this.obj_data.booking_status]) {
        this.list_action_detail = map_action[this.obj_data.booking_status];
      }

    },
    async onActionClickedNeedToPaid(payload) {
      console.log('payloadpayloadpayloadpayloadpayloadpayloadpayload', payload);

      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (data.data?.status == 'ST002') {
            this.$router.push({path: `/admin/list-visit/edit/${data.data?.order?.visit?.id}`})
            return;
          }
          if (action.path !== undefined && action.path) {
            this.$router.push({path: action.path + data.data[action.key]})
          } else {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            console.log("payload.lazyParams:111" + pageTransaction, payload.lazyParams);
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({
              path: action.path + data.data[action.key],
              query: {page_transaction: pageTransaction.toString()}
            })
          } else {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          console.log('aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa', data.data[action.key]);
          this.codePayment = data.data.code;
          localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
          this.page_transaction = pageTransaction;
          console.log(data.data);
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({path: action.path})
          } else {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'confirm':
          this.codePayment = data.data.code;
          localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
          this.page_transaction = pageTransaction;
          console.log(data.data);
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.showConfirmDialog = true
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    getRowActionsNeedToPaid() {
      var actions = {}
      var that = this;
      //if (this.role.add) {
      actions.header = {name: 'add', icon: 'plus', path: `list-payment_history/add`};
      //}
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        console.log('111111111111111111111111111111111111111', rowData.status);

        var buttons = {}
        if (rowData.status == 'Need to pay') {
          buttons.view = {name: 'confirm', icon: 'check-circle', key: 'id', path: `list-payment_history/view/`};
          //if (that.role.delete) {
          buttons.delete = {name: 'delete', icon: 'trash', key: 'id'}
          // }
        }
        //  if (rowData.status === 'Need to pay' && rowData.type === 3) {
        //   if (that.role.edit) {
        //     buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `list-${that.modelName}/edit/` };
        //   }
        // }
        // buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `${that.modelName}/edit/`}


        if (that.dataModelNeedToPay.actions) {
          var modelaction = that.dataModelNeedToPay.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async click_change_status(code) {
      // var code_order = this.obj_data.code
      // var prefix_code = code_order.substring(0, 2);
      switch (code) {
          // case this.$constants.STATUS_ORDER.EDIT:
          //   var url_edit = `/admin/list-order/edit/${this.model.id}`
          //   if (!this.$commonFuction.isEmpty(this.$route.query)){
          //     if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
          //       url_edit +=`?page_transaction=${this.$route.query.page_transaction}`
          //     }
          //   }
          //   console.log("url_editurl_edit:",url_edit)
          //   window.location.href = url_edit
          //   break;
        case 'CONFIRM_PICK_UP':
          this.showConfirmDialog = true;
          // var rent_car_for_rent_id_event_tmp = this.obj_data.rent_car_for_rent_id_event;
          // this.$set(this.obj_data, 'rent_car_for_rent_id_event', null);
          // this.$set(this.obj_data, 'rent_car_for_rent_id_event', null);
          break;
        case 'CANCEL_RENT':
          this.showCancelDialog = true;
          break;
        case 'EDIT':
          window.location.href = `/admin/list-rental_order/edit/${this.model.id}`
          break;


        case 'CHANGE_CAR':
          this.getListCarForRentEvent();
          this.showChangeCarDialog = true;
          break;
        case 'RESET_LATE_FEE':
          this.showResetLateFeeDialog = true;
          break;
        case 'RENEW_CONTRACT':
          this.showRenewContractDialog = true;
          break;

        default:
          //text = "Looking forward to the Weekend";
      }
    },
    change_allow_car_category() {
      this.$set(this.obj_data, 'rent_car_for_rent_id', null);
    },
    change_allow_car_category_event() {
      this.$set(this.obj_data, 'rent_car_for_rent_id_event', null);
    },
    change_car_for_rent_event() {
      this.key_car_for_rent_event++;
      this.key_car_for_rent_color_event++;
      console.log("this.obj_data.rent_car_for_rent_id_event:3333333333333");
      //this.generate_data();
    },
    change_car_for_rent() {
      this.key_car_for_rent++;
      //this.generate_data();
    },
    generate_data() {
      var post_id = "";
      console.log(
          "this.obj_data.rent_available_iddddddddddddd:",
          this.obj_data.rent_available_id
      );
      if (!this.$commonFuction.isEmpty(this.obj_data.rent_available_id)) {
        post_id =
            this.map_available_for_rent_all[this.obj_data.rent_available_id]
                ?.code;
      }
      this.obj_data.post_id = post_id;
      console.log("this.obj_data.rent_car_for_rent_id:444444444");

      if (!this.$commonFuction.isEmpty(this.obj_data.rent_car_for_rent_id)) {
        console.log(
            "this.obj_data.object:",
            this.map_car_for_rent_id_all[this.obj_data.rent_car_for_rent_id]
        );
        this.obj_data.color_car_forent =
            this.map_car_for_rent_id_all[
                this.obj_data.rent_car_for_rent_id
                ]?.color;
      } else {
        this.obj_data.color_car_forent = null;
      }
    },
    core_disable(input_name = "") {
      // console.log("sasasawqwqfdf")
      var is_return = false;
      //dùng switch case để xử lý các trường hợp disable
      switch (input_name) {
        case "booking_status":
          if (this.mode == "edit") {
            is_return = true;
          }
          break;
        case "color_car_forent":
          is_return = true;
          break;
        case "created_at":
          is_return = true;
          break;
        case "post_id":
          is_return = true;
          break;
        case "rent_available_id":
          is_return = false;
          break;
        case "rent_vehicle_category_id":
          is_return = false;
          break;
        case "rent_term_id":
          is_return = false;
          break;
        case "rent_pick_up_date":
          is_return = false;
          break;
        case "rent_valid_until":
          is_return = false;
          break;
        case "showroom_id":
          is_return = false;
          break;
        case "contract_id":
          is_return = false;
          break;
        case "note":
          is_return = false;
          break;
        case "uid":
          is_return = false;
          break;
        case "rent_contact_name":
          is_return = false;
          break;
        case "rent_contact_phone":
          is_return = false;
          break;
        case "rent_contact_email":
          is_return = false;
          break;
        case "rent_identification_information":
          is_return = false;
          break;
        case "rent_number_id":
          is_return = false;
          break;
        case "rent_pay_price_per_week":
          is_return = false;
          break;
        case "rent_pay_bond_fee":
          is_return = false;
          break;
        case "rent_late_fee_threshold":
          is_return = false;
          break;
        case "rent_late_fee_per_day":
          is_return = false;
          break;
        case "rent_booking_fee":
          if (this.mode == "edit") {
            is_return = true;
          }
          break;
        case "rent_voucher_id":
          is_return = false;
          break;
        case "is_pay_booking_fee":
          is_return = false;
          break;
        default:
      }
      // console.log("is_return:"+input_name,is_return)
      return is_return;
    },
    core_display_view(input_name = "") {
      //dùng switch case để xử lý các trường hợp disable
      var is_return = false;
      switch (input_name) {
        case "rent_late_fee_threshold_edit":
          if (this.mode == "edit") {
            is_return = true;
            //console.log("rent_late_fee_threshold_edit",is_return)
          }
          break;
        case "rent_late_fee_per_day_edit":
          if (this.mode == "edit") {
            is_return = true;
            // console.log("rent_late_fee_per_day_edit",is_return)
          }
          break;
        case "rent_late_fee_per_day_add":
          if (this.mode == "add") {
            is_return = true;
            //  console.log("rent_late_fee_per_day_add",is_return)
          }
          break;
        case "rent_late_fee_threshold_add":
          if (this.mode == "add") {
            is_return = true;
            //  console.log("rent_late_fee_threshold_add",is_return)
          }
          break;
        case "group_car_forrent_id":
          if (this.mode != "add") {
            is_return = true;
          }
          break;
        case "is_allow_car_category":
          if (this.mode == "edit") {
            is_return = true;
          }
          break;
        case "group_created_at_post_id":
          if (this.mode != "add") {
            is_return = true;
          }
          break;
        case "booking_status":
          if (this.mode == "edit") {
            is_return = true;
          }
          break;
        case "created_at":
          is_return = true;
          break;
        case "rent_available_id":
          if (this.mode == "add") {
            is_return = true;
          }
          break;
        case "rent_vehicle_category_id":
          is_return = false;
          break;
        case "rent_term_id":
          is_return = false;
          break;
        case "rent_pick_up_date":
          is_return = false;
          break;
        case "rent_valid_until":
          is_return = false;
          break;
        case "showroom_id":
          is_return = false;
          break;
        case "contract_id":
          is_return = false;
          break;
        case "note":
          is_return = false;
          break;
        case "uid":
          is_return = false;
          break;
        case "rent_contact_name":
          is_return = false;
          break;
        case "rent_contact_phone":
          is_return = false;
          break;
        case "rent_contact_email":
          is_return = false;
          break;
        case "rent_identification_information":
          is_return = false;
          break;
        case "rent_number_id":
          is_return = false;
          break;
        case "rent_pay_price_per_week":
          is_return = false;
          break;
        case "rent_pay_bond_fee":
          is_return = false;
          break;
        case "rent_late_fee_threshold":
          is_return = false;
          break;
        case "rent_late_fee_per_day":
          is_return = false;
          break;
        case "rent_booking_fee":
          is_return = false;
          break;
        case "rent_voucher_id":
          if (this.mode == "add") {
            is_return = true;
          }
          break;
        case "is_pay_booking_fee":
          if (this.mode == "add") {
            is_return = true;
          }
          break;
        default:
      }
      return is_return;
    },
    //is_change_price
    async change_price_common() {
      this.is_change_price = true;
    },
    // function call api api_admin/order/list_voucher get list voucher
    // call api
    async loadVoucher() {
      this.obj_data.rent_voucher_id = null;
      var user_id = this.obj_data.uid;
      var term_id = this.obj_data.rent_term_id;
      console.log("user_id:", user_id);
      console.log("term_id:", term_id);
      if (
          this.$commonFuction.isEmpty(user_id) ||
          this.$commonFuction.isEmpty(term_id)
      ) {
        this.list_voucher = [];
        return;
      }
      var dataRequest = {
        user_id: user_id,
        term_id: term_id,
        type_condition: 2,
      };
      const headers = {
        Authorization: "Bearer " + (await this.$AuthenticationApp.getToken()),
      };
      var list_action_detail = await ApiRepository.post(
          "/api_admin/order/list_voucher",
          dataRequest,
          {headers}
      );
      var listData = list_action_detail["data"]["data"];
      console.log("listData:", listData);
      this.list_voucher = listData;
    },
    async change_list_user() {
      //loa
      this.loadVoucher();
    },
    removeSpaces() {
      // Loại bỏ tất cả khoảng cách
      this.obj_data.phone = this.obj_data.phone.replace(/\s+/g, "");
    },
    async getListUser() {
      var where_key = {
        deleted: {_eq: false},
        role: {_eq: this.$constants.ROLE_ACCOUNT.USER},
        // booking: {id: {_is_null: true} },
      };
      var list = await this.$CoreService.getListUser(where_key);
      this.listUser = list.list;
      this.listUserAll = list.list;
    },
    async SearchUser(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
          role: {_eq: this.$constants.ROLE_ACCOUNT.USER},
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.fullname = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListUser(where_key);
        this.listUser = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.listUser = this.listUserAll;
      }
    },
    async change_list_voucher() {
      this.key_voucher++;
    },
    async changeState() {
      this.key_state++;
    },
    async change_rent_pick_up_date() {
      this.calcValidUntil();
    },
    async change_list_term() {
      // this.obj_data.rent_term_id =null;
      // this.getListTerm(this.obj_data.rent_vehicle_category_id);
      // this.key_term++;
      var item_term = this.map_term_id_all[this.obj_data.rent_term_id];
      if (this.is_change_price == false) {
        this.obj_data.rent_booking_fee = item_term.booking_fee;
        this.obj_data.rent_pay_price_per_week = item_term.price_per_unit;
      }

      this.calcValidUntil();
      this.loadVoucher();
    },
    calcValidUntil() {
      if (
          !this.$commonFuction.isEmpty(this.obj_data.rent_pick_up_date) &&
          !this.$commonFuction.isEmpty(this.obj_data.rent_term_id)
      ) {
        var item_term = this.map_term_id_all[this.obj_data.rent_term_id];
        //  var day_term = getDurationInDays(item_term.unit_duration,item_term.duration);
        var day_term = this.$CoreService.getDurationInDays(
            item_term.unit_duration,
            item_term.duration
        );
        const rent_pick_up_date = moment(this.obj_data.rent_pick_up_date);
        //const rent_pick_up_dateFormat = moment(this.obj_data.rent_pick_up_date).format(this.$constants.DB_FORMAT_DATE_TIME);
        const rent_valid_until = rent_pick_up_date
            .add(day_term, "days")
            .format(this.$constants.DB_FORMAT_DATE_TIME_NOT_SS);
        this.obj_data.rent_valid_until = new Date(rent_valid_until);

        console.log("rent_valid_until:", rent_valid_until);
        // this.key_rent_pick_up_date
      }
    },
    async getListTerm(rent_vehicle_category_id = null) {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      if (!this.$commonFuction.isEmpty(rent_vehicle_category_id)) {
        where_key["vehicle_category_id"] = {_eq: rent_vehicle_category_id};
      }
      var list = await this.$CoreService.getListTerm(where_key);
      this.list_term_id = list.list;
      this.list_term_id_all = list.list;
      this.map_term_id_all = list.map_list;
    },
    async SearchTerm(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (!this.$commonFuction.isEmpty(this.model.rent_vehicle_category_id)) {
          where_key["rent_vehicle_category_id"] = {
            _eq: this.model.rent_vehicle_category_id,
          };
        }
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListTerm(where_key);
        this.list_term_id = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        this.list_term_id = this.list_term_id_all;
      }
    },
    //event getListTerm
    async getListTermEvent(rent_vehicle_category_id = null) {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      if (!this.$commonFuction.isEmpty(rent_vehicle_category_id)) {
        where_key["vehicle_category_id"] = {_eq: rent_vehicle_category_id};
      }
      var list = await this.$CoreService.getListTerm(where_key);
      this.list_term_id_event = list.list;
      this.list_term_id_all_event = list.list;
      this.map_term_id_all_event = list.map_list;
    },
    async SearchTermEvent(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (!this.$commonFuction.isEmpty(this.model.rent_vehicle_category_id)) {
          where_key["rent_vehicle_category_id"] = {
            _eq: this.model.rent_vehicle_category_id,
          };
        }
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListTerm(where_key);
        this.list_term_id_event = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        this.list_term_id_event = this.list_term_id_all_event;
      }
    },  //event getListCarForRent
    //list_car_for_rent_id_event
    async getListCarForRentEvent() {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      if (this.obj_data.is_allow_car_category_event != true) {
        where_key["vehicle_category_id"] = {
          _eq: this.obj_data.rent_vehicle_category_id_root,
        };
      }
      var list = await this.$CoreService.getListCarForRent(where_key);
      this.list_car_for_rent_id_event = list.list;
      this.list_car_for_rent_id_all_event = list.list;
      this.map_car_for_rent_id_all_event = list.map_list;
    },
    async SearchCarForRentPick_event(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (this.obj_data.is_allow_car_category_event != true) {
          where_key["vehicle_category_id"] = {
            _eq: this.obj_data.rent_vehicle_category_id_root,
          };
        }
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.license_plate_number = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListCarForRent(where_key);
        this.list_car_for_rent_id_event = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.list_car_for_rent_id_event = this.list_car_for_rent_id_all_event;
      }
    },

    //car_for_rent_id
    async getListCarForRent() {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      if (this.obj_data.is_allow_car_category != true) {
        where_key["vehicle_category_id"] = {
          _eq: this.obj_data.rent_vehicle_category_id,
        };
      }
      var list = await this.$CoreService.getListCarForRent(where_key);
      this.list_car_for_rent_id = list.list;
      this.list_car_for_rent_id_all = list.list;
      this.map_car_for_rent_id_all = list.map_list;
    },
    async SearchCarForRent(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (this.obj_data.is_allow_car_category != true) {
          where_key["vehicle_category_id"] = {
            _eq: this.obj_data.rent_vehicle_category_id,
          };
        }
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.license_plate_number = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListCarForRent(where_key);
        this.list_car_for_rent_id = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.list_car_for_rent_id = this.list_car_for_rent_id_all;
      }
    },
    async change_list_vehicle_category() {
      var item_category =
          this.map_vehicle_category_id_all[
              this.obj_data.rent_vehicle_category_id
              ];
      if (this.is_change_price == false) {
        this.obj_data.rent_pay_bond_fee = item_category.bond_fee;
      }
      this.obj_data.rent_term_id = null;
      this.getListTerm(this.obj_data.rent_vehicle_category_id);
      this.key_term++;
    },
    //rent_car_for_rent_id =null
    async getListVehicleCategory() {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      // if (!this.$commonFuction.isEmpty(rent_car_for_rent_id)){
      //   where_key["rent_car_for_rent_id"] =  {_eq : rent_car_for_rent_id}
      // }
      var list = await this.$CoreService.getLisVehicleCategory(where_key);
      this.list_vehicle_category_id = list.list;
      this.list_vehicle_category_id_all = list.list;
      this.map_vehicle_category_id_all = list.map_list;
    },
    async SearchVehicleCategory(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        // if (!this.$commonFuction.isEmpty(this.model.rent_car_for_rent_id)){
        //   where_key["rent_car_for_rent_id"] =  {_eq : this.model.rent_car_for_rent_id}
        // }
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getLisVehicleCategory(where_key);
        this.list_vehicle_category_id = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.list_vehicle_category_id = this.list_vehicle_category_id_all;
      }
    },
    async getList_showroom() {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      var list = await this.$CoreService.getLisShowroom(where_key);
      this.list_showroom_id = list.list;
      this.list_showroom_id_all = list.list;
      this.map_showroom_id_all = list.map_list;
    },
    async Search_showroom(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getLisShowroom(where_key);
        this.list_showroom_id = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.list_showroom_id = this.list_showroom_id_all;
      }
    },
    //list_available_for_rent
    async change_list_available_for_rent() {
      //   this.obj_data.state_id =null;
      //   this.getListVehicleCategory(this.obj_data.rent_car_for_rent_id);
      // //  this.key_form++;
      //   this.key_vehicle_category++;
      if (this.$commonFuction.isEmpty(this.obj_data.rent_vehicle_category_id)) {
        var item_car =
            this.map_available_for_rent_all[this.obj_data.rent_available_id];
        this.obj_data.rent_vehicle_category_id = item_car.vehicle_category_id;
        this.getListTerm(this.obj_data.rent_vehicle_category_id);
      }
    },
    async getList_available_for_rent() {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      var list = await this.$CoreService.getListAvailableForRent(where_key);
      this.list_available_for_rent = list.list;
      this.list_available_for_rent_all = list.list;
      this.map_available_for_rent_all = list.map_list;
    },
    async Search_available_for_rent(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.code = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListAvailableForRent(where_key);
        this.list_available_for_rent = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.list_available_for_rent = this.list_available_for_rent_all;
      }
    },

    async changeCountry() {
      this.obj_data.state_id = null;
      this.getListState(this.obj_data.country_id);
      //  this.key_form++;
      this.key_state++;
    },
    async getListCountry() {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      var list = await this.$CoreService.getListCountry(where_key);
      this.listCountry = list.list;
      this.listCountryAll = list.list;
      this.mapCountryAll = list.map_list;
    },
    async SearchCountry(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListCountry(where_key);
        this.listCountry = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.listCountry = this.listCountryAll;
      }
    },
    async getListState(country_id = null) {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      if (!this.$commonFuction.isEmpty(country_id)) {
        where_key["country_id"] = {_eq: country_id};
      }
      var list = await this.$CoreService.getListState(where_key);
      this.listState = list.list;
      this.listStateAll = list.list;
    },
    async SearchState(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (!this.$commonFuction.isEmpty(this.model.country_id)) {
          where_key["country_id"] = {_eq: this.model.country_id};
        }
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListState(where_key);
        this.listState = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.listState = this.listStateAll;
      }
    },
    switchVisibility(event, type = null) {
      console.log("event:", event);
      console.log("typetype:", type);
      if (type == "re") {
        this.passwordReType =
            this.passwordReType === "password" ? "text" : "password";
      } else {
        this.passwordType =
            this.passwordType === "password" ? "text" : "password";
      }
    },
    async deleteData() {
      this.showDeleteDialog = false;
      var list_data = [];
      for (let i = 0; i < this.listDataUserFamily.length; i++) {
        var item_data = this.listDataUserFamily[i];
        if (this.deleteId != item_data.id) {
          list_data.push(item_data);
        }
      }
      this.listDataUserFamily = list_data;
      this.loadTableUserFamily();
    },
    async loadTableUserFamily() {
      var stt = 0;
      var listDataUserFamily = this.listDataUserFamily;
      //this.mapServicePriceProduct = {};
      for (let i = 0; i < listDataUserFamily.length; i++) {
        stt++;
        //var itemData = listDataUserFamily[i];
        //var id = itemData?.id ?? null;
        listDataUserFamily[i].stt = stt;
        listDataUserFamily[i].index = i;
        // this.mapServicePriceProduct[id] = itemData;
      }
      this.listDataUserFamily = listDataUserFamily;
      // console.log(" this.listDataUserFamily:", this.listDataUserFamily)
      this.dataModelUserFamily = DataServices.getModel("user_family");
      //this.dataModelProduct.processData(listDataUserFamily)
      this.componentKeyUserFamily++;
    },
    async validateDataUserFamily() {
      if (this.$commonFuction.isEmpty(this.dataFamily.name)) {
        alert("Please enter Fullname");
        return true;
      }
      if (
          !this.$commonFuction.isEmpty(this.dataFamily.prefix_phone) ||
          !this.$commonFuction.isEmpty(this.dataFamily.phone)
      ) {
        if (
            this.$commonFuction.isEmpty(this.dataFamily.prefix_phone) ||
            this.$commonFuction.isEmpty(this.dataFamily.phone)
        ) {
          alert("Please enter Phone number");
          return true;
        }
      }
      if (!this.$commonFuction.isEmpty(this.dataFamily.email)) {
        if (!(await this.$commonFuction.IsEmail(this.dataFamily.email))) {
          alert("Email is not in correct format!");
          return true;
        }
      }

      if (this.list_file_product.length > 0) {
        if (this.list_file_product.length != 2) {
          alert("Please choose 2 photos!");
          return true;
        }
      }
    },
    async saveDataUserFamily() {
      var that = this;
      if (await this.validateDataUserFamily()) {
        return;
      }
      this.$commonFuction.is_loading(true);
      //console.log("this.from_to", this.from_to);
      //console.log("partArr", this.dataBookingRound);
      var params = this.dataFamily;
      //delete this.dataFamilyDisplay
      console.log("paramsparams:", params);
      var id = params?.id ?? null;
      var itemObject = {
        // stt:1,
        list_id_file_delete_product: this.list_id_file_delete_product,
        //avatar:this.list_file_product[0].objectURL,
        list_file_product: this.list_file_product,
        image_list: this.list_file_product,
        name: params?.name ?? null,
        email: params?.email ?? null,
        personal_id: params?.personal_id ?? null,
        relationship: params?.relationship ?? null,
        phone: params?.phone ?? null,
        prefix_phone: params?.prefix_phone ?? null,
        phone_txt: null,
      };
      if (
          !this.$commonFuction.isEmpty(params.phone) &&
          !this.$commonFuction.isEmpty(params.prefix_phone)
      ) {
        itemObject.phone_txt = params.prefix_phone + params.phone;
      }

      if (!this.$commonFuction.isEmpty(id)) {
        itemObject["id"] = id;
        this.listDataUserFamily[params?.index] = itemObject;
      } else {
        itemObject["id"] = moment().valueOf() + "";
        itemObject["is_new"] = 1; //sp này do thêm mới chứ ko từ edit dat trong db
        this.listDataUserFamily.push(itemObject);
      }
      console.log("itemObjectitemObject:", itemObject);

      this.loadTableUserFamily();

      setTimeout(function () {
        //Gọi API refeshtoken
        that.dataFamilyDisplay = false;
        that.$commonFuction.is_loading(false);
        that.clearSaveUserFamily();
      }, 1000);

      /*params["list_file"] = this.list_file
      params["list_type"] = this.listDataUserFamily
      params["list_madatory"] = this.listDataMadatory
      params["list_lang"] = this.listLang
      params["list_id_file_delete"] = this.list_id_file_delete
      console.log('saveData', params)
      this.$emit('save', params)*/
    },
    clearSaveUserFamily() {
      this.dataFamily.id = null;
      this.dataFamily.name = "";
      this.dataFamily.relationship = "";
      this.dataFamily.prefix_phone = "";
      this.dataFamily.phone = "";
      this.dataFamily.email = "";
      this.dataFamily.personal_id = "";
      this.list_file_product = [];
      this.list_id_file_delete_product = [];
    },
    async onActionClicked(payload) {
      var action = payload.action;
      var data = null;
      if (payload.data) {
        data = payload.data;
      }
      var pageTransaction = new Date().getTime();
      console.log("action.nameaction.name:", action.name);
      switch (action.name) {
        case "view":
          this.dialogMode = action.name;
          if (action.path !== undefined && action.path) {
            this.$router.push({path: action.path + data.data[action.key]});
          } else {
            this.editId = data.data[action.key];
            this.displayDialog = true;
            this.editDialogKey++;
          }
          break;
        case "edit":
          //console.log("datadatadata:",data)
          /*this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            console.log("payload.lazyParams:111"+pageTransaction,payload.lazyParams);
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key],query: { page_transaction: pageTransaction.toString() }  })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }*/ /*
          this.index_edit =data.data.index
          this.obj_data.type_id =data.data.id
          this.obj_data.price_select =data.data.price_key
          this.key_type_id++;

          this.dataFamilyDisplay = true*/
          console.log("data.datadata.data:", data.data);

          this.list_file_product = data.data?.list_file_product ?? [];
          this.list_id_file_delete_product =
              data.data?.list_id_file_delete_product ?? [];
          /*if (this.list_file_product.length > 0){
            delete data.data.list_file_product;
            delete data.data.image_list;
          }
          console.log("data.datadata.data11:",data.data)
          this.dataFamily = this.$commonFuction.convertJsonObject(data.data)*/
          /* this.dataFamily = data.data
          if (this.list_file_product.length > 0){
            delete this.dataFamily.list_file_product;
            delete this.dataFamily.image_list;
          }*/
          this.dataFamily = {};

          var key_not = ["list_file_product", "image_list"];
          var data_edit = data.data;
          for (let key in data_edit) {
            // if (data_edit.hasOwnProperty(key)) {
            // if (data_edit.hasOwnProperty(key)) { // Check if the property is directly on the object
            // console.log(key + ': ' + person[key]);
            if (key_not.indexOf(key) == -1) {
              this.dataFamily[key] = data_edit[key];
              //  }
            }
          }

          /*this.dataFamily.list_file_product =this.list_file_product;
          this.dataFamily.image_list =this.list_file_product;*/
          //this.dataFamily.list_id_file_delete_product =  this.list_id_file_delete_product;
          this.dataFamilyDisplay = true;
          this.componentDataFamily++;
          break;
        case "delete":
          localStorage.setItem(
              pageTransaction.toString(),
              JSON.stringify(payload.lazyParams)
          );
          this.page_transaction = pageTransaction;
          this.deleteId = data.data[action.key];
          console.log("this.deleteId:", this.deleteId);
          this.deleteName = data.data.name;
          this.showDeleteDialog = true;
          break;
        case "add":
          this.dataFamilyDisplay = true;
          this.componentDataFamily++;
          console.log("this.componentDataFamily:", this.componentDataFamily);
          /*
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }*/
          break;
        case "custom":
          await action.handler(data.data, this);
          this.componentKey++;
          break;
      }
    },
    getRowActions() {
      var actions = {};
      var that = this;
      //if (this.role.add) {
      actions.header = {
        name: "add",
        icon: "plus",
        path: `list-${this.modelName}/add`,
      };
      //}
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {};
        //buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-${that.modelName}/view/`};
        //if (that.role.edit) {
        buttons.edit = {
          name: "edit",
          icon: "pencil",
          key: "id",
          path: `list-${that.modelName}/edit/`,
        };
        //}
        // buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `${that.modelName}/edit/`}
        //if (that.role.delete) {
        buttons.delete = {name: "delete", icon: "trash", key: "id"};
        //}
        if (that.dataModelUserFamily.actions) {
          var modelaction = that.dataModelUserFamily.actions(rowData);
          Object.assign(buttons, modelaction);
        }
        return buttons;
      };
      return actions;
    },
    onFileClearProduct(item, index) {
      console.log("itemitem:", item);
      var type = item?.type ?? null;
      if (type == "old_edit") {
        this.list_id_file_delete_product.push(item.id);
      }
      this.list_file_product.splice(index, 1);
    },
    async onFileSelectFileProduct(event) {
      var that = this;
      let files = event.target.files || event.dataTransfer.files;
      console.log("filesfiles:", files);
      console.log("files.length:", files.length);
      if (files.length > 0) {
        let acceptTags = [
          "jpeg",
          "jpg",
          "gif",
          "png",
          "JPEG",
          "JPG",
          "PNG",
          "GIF",
          "svg",
          "SVG",
        ];
        console.log("files.length1111111:", files.length);
        for (let i = 0; i < files.length; i++) {
          console.log("files.333333333333:", files.length);
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            alert("Only post formats are supported: jpeg, jpg, gif, png, svg");
            return;
          }
          //  document.getElementById('file_name').innerText = files[i].name;
          console.log("files[i].namefiles[i].name:", files[i].name);
          that.obj_data.filename = files[i].name;
          this.comFilename++;
        }
        var arrTemp = [],
            arrFiles = [];
        for (let file of files) {
          console.log("file.sizefile.sizefile.size:", file.size);
          if (file.size <= this.maxFileSize) {
            file.source = file;
            file.objectURL = window.URL.createObjectURL(file);
            console.log("asdasdasfile:", file);
            arrTemp.push(file);
          }
          if (file.size > this.maxFileSize) arrFiles.push(file);
        }
        if (arrFiles.length > 0) {
          alert("Your image is larger 100MB");
          that.obj_data.filename = "";
          return;
        } else {
          // if (this.icon_service.length > 0 && this.icon_service[0].file === '') {
          //   this.imagesDeletes.push(this.icon_service[0])
          // }
          console.log("arrTemparrTemp:", arrTemp);
          //this.list_file_product = [];
          this.list_file_product = this.list_file_product.concat.apply(
              this.list_file_product,
              arrTemp
          );
        }
      }
      this.$refs.fileInputProduct.value = null;
    },
    onFileClear(item, index) {
      console.log("itemitem:", item);
      var type = item?.type ?? null;
      if (type == "old_edit") {
        this.list_id_file_delete.push(item.id);
      }
      this.list_file.splice(index, 1);
    },
    async onFileSelectFileAfter(event) {
      var that = this;
      let files = event.target.files || event.dataTransfer.files;
      console.log("filesfiles:", files);
      console.log("files.length:", files.length);
      if (files.length > 0) {
        let acceptTags = [
          "jpeg",
          "jpg",
          "gif",
          "png",
          "JPEG",
          "JPG",
          "PNG",
          "GIF",
          "svg",
          "SVG",
        ];
        console.log("files.length1111111:", files.length);
        for (let i = 0; i < files.length; i++) {
          console.log("files.333333333333:", files.length);
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            alert("Only post formats are supported: jpeg, jpg, gif, png, svg");
            return;
          }
          //  document.getElementById('file_name').innerText = files[i].name;
          console.log("files[i].namefiles[i].name:", files[i].name);
          that.obj_data.filename = files[i].name;
          this.comFilenameAfter++;
        }
        var arrTemp = [],
            arrFiles = [];
        for (let file of files) {
          console.log("file.sizefile.sizefile.size:", file.size);
          if (file.size <= this.maxFileSize) {
            file.source = file;
            file.objectURL = window.URL.createObjectURL(file);
            console.log("asdasdasfile:", file);
            arrTemp.push(file);
          }
          if (file.size > this.maxFileSize) arrFiles.push(file);
        }
        if (arrFiles.length > 0) {
          alert("Your image is larger 100MB");
          that.obj_data.filename = "";
          return;
        } else {
          // if (this.icon_service.length > 0 && this.icon_service[0].file === '') {
          //   this.imagesDeletes.push(this.icon_service[0])
          // }
          console.log("arrTemparrTemp:", arrTemp);
          this.list_file_after = [];
          this.list_file_after = this.list_file_after.concat.apply(
              this.list_file_after,
              arrTemp
          );
        }
      }
      this.$refs.fileInputAfter.value = null;
    },
    async onFileClearAfter(item, index) {
      console.log("itemitem:", item);
      var type = item?.type ?? null;
      if (type == "old_edit") {
        this.list_id_file_delete_after.push(item.id);
      }
      this.list_file_after.splice(index, 1);
    },
    async onFileSelectFile(event) {
      var that = this;
      let files = event.target.files || event.dataTransfer.files;
      console.log("filesfiles:", files);
      console.log("files.length:", files.length);
      if (files.length > 0) {
        let acceptTags = [
          "jpeg",
          "jpg",
          "gif",
          "png",
          "JPEG",
          "JPG",
          "PNG",
          "GIF",
          "svg",
          "SVG",
        ];
        console.log("files.length1111111:", files.length);
        for (let i = 0; i < files.length; i++) {
          console.log("files.333333333333:", files.length);
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            alert("Only post formats are supported: jpeg, jpg, gif, png, svg");
            return;
          }
          //  document.getElementById('file_name').innerText = files[i].name;
          console.log("files[i].namefiles[i].name:", files[i].name);
          that.obj_data.filename = files[i].name;
          this.comFilename++;
        }
        var arrTemp = [],
            arrFiles = [];
        for (let file of files) {
          console.log("file.sizefile.sizefile.size:", file.size);
          if (file.size <= this.maxFileSize) {
            file.source = file;
            file.objectURL = window.URL.createObjectURL(file);
            console.log("asdasdasfile:", file);
            arrTemp.push(file);
          }
          if (file.size > this.maxFileSize) arrFiles.push(file);
        }
        if (arrFiles.length > 0) {
          alert("Your image is larger 100MB");
          that.obj_data.filename = "";
          return;
        } else {
          // if (this.icon_service.length > 0 && this.icon_service[0].file === '') {
          //   this.imagesDeletes.push(this.icon_service[0])
          // }
          console.log("arrTemparrTemp:", arrTemp);
          this.list_file = [];
          this.list_file = this.list_file.concat.apply(this.list_file, arrTemp);
        }
      }
    },
    isImage(file) {
      return /^image\//.test(file.type);
    },
    updateMatrix(data) {
      console.log(data);
      this.dataBookingRound = [...data];
      // this.componentKey++;
    },
    async toCalendar() {
      this.$router.push(
          `/admin/list-booking?view=calendar&propery_id=${this.selProperty?.id}`
      );
    },
    async getListProperty() {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      var list = await this.$CoreService.getListProperty(where_key);
      this.listProperty = list.list;
      this.listPropertyAll = list.list;
    },

    async SearchProperty(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListProperty(where_key);
        this.listProperty = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.listProperty = this.listPropertyAll;
      }
    },

    async getListDocsCate() {
      var where_key = {
        deleted: {_eq: false},
        // booking: {id: {_is_null: true} },
      };
      var list = await this.$CoreService.getListDocsCate(where_key);
      this.listDocsCate = list.list;
      this.listDocsCateAll = list.list;
    },

    async SearchDocsCate(search, loading) {
      console.log(loading);
      if (search !== "" && search !== null) {
        var where_key = {
          deleted: {_eq: false},
        };
        if (!this.$commonFuction.isEmpty(search)) {
          where_key.name = {
            _iregex: this.$commonFuction.search(search),
          };
        }
        var list = await this.$CoreService.getListDocsCate(where_key);
        this.listDocsCate = list.list;
        //console.log("this.listProperty:",this.listProperty)
      } else {
        // cosnole.log("dasdasd")
        this.listDocsCate = this.listDocsCateAll;
      }
    },

    backToList() {
     // this.$emit("back");
       this.$router.push({path: `/admin/list-rental_order/view/${this.$route.params.id}`});
    },
    validatePhoneNumber(phone) {
      // Biểu thức chính quy cho số điện thoại có thể có hoặc không có dấu +, không có dấu (), và -
      const phoneRegex = /^\+?[0-9\s]{7,15}$/;
      return phoneRegex.test(phone);
    },
    async validateData() {
      this.validationErrors = {};

      let tmp_booking_status = document.getElementById("tmp_booking_status");
      if (this.$commonFuction.isEmpty(this.obj_data.booking_status)) {
        tmp_booking_status.setCustomValidity(
            this.$constants.MSG_TEXT.SELECT_INVALID_MSG
        );
      } else {
        tmp_booking_status.setCustomValidity("");
      }
      //validate các field required vd vehicle category
      let tmp_rent_vehicle_category_id = document.getElementById(
          "tmp_rent_vehicle_category_id"
      );
      if (this.$commonFuction.isEmpty(this.obj_data.rent_vehicle_category_id)) {
        tmp_rent_vehicle_category_id.setCustomValidity(
            this.$constants.MSG_TEXT.SELECT_INVALID_MSG
        );
      } else {
        tmp_rent_vehicle_category_id.setCustomValidity("");
      }
      let tmp_rent_term_id = document.getElementById("tmp_rent_term_id");
      if (this.$commonFuction.isEmpty(this.obj_data.rent_term_id)) {
        tmp_rent_term_id.setCustomValidity(
            this.$constants.MSG_TEXT.SELECT_INVALID_MSG
        );
      } else {
        tmp_rent_term_id.setCustomValidity("");
      }
      // let tmp_rent_car_for_rent_id = document.getElementById("tmp_rent_car_for_rent_id");
      // if (this.$commonFuction.isEmpty(this.obj_data.rent_car_for_rent_id)){
      //   tmp_rent_car_for_rent_id.setCustomValidity(this.$constants.MSG_TEXT.SELECT_INVALID_MSG);
      // }else {
      //   tmp_rent_car_for_rent_id.setCustomValidity("");
      // }
      let tmp_showroom_id = document.getElementById("tmp_showroom_id");
      if (this.$commonFuction.isEmpty(this.obj_data.showroom_id)) {
        tmp_showroom_id.setCustomValidity(
            this.$constants.MSG_TEXT.SELECT_INVALID_MSG
        );
      } else {
        tmp_showroom_id.setCustomValidity("");
      }
      //renter
      var tmp_rent_pick_up_date = document.getElementById(
          "tmp_rent_pick_up_date"
      );
      if (this.$commonFuction.isEmpty(this.obj_data.rent_pick_up_date)) {
        tmp_rent_pick_up_date.setCustomValidity(
            this.$constants.MSG_TEXT.INPUT_INVALID_MSG
        );
      } else {
        //check ngày bị sai format
        if (moment(this.obj_data.rent_pick_up_date).isValid() == false) {
          tmp_rent_pick_up_date.setCustomValidity(
              "Date is not in correct format!"
          );
        } else {
          tmp_rent_pick_up_date.setCustomValidity("");
        }
      }
      var tmp_rent_valid_until = document.getElementById(
          "tmp_rent_valid_until"
      );
      if (this.$commonFuction.isEmpty(this.obj_data.rent_valid_until)) {
        tmp_rent_valid_until.setCustomValidity(
            this.$constants.MSG_TEXT.INPUT_INVALID_MSG
        );
      } else {
        tmp_rent_valid_until.setCustomValidity("");
      }
      var tmp_uid = document.getElementById("tmp_uid");
      if (this.$commonFuction.isEmpty(this.obj_data.uid)) {
        tmp_uid.setCustomValidity(this.$constants.MSG_TEXT.SELECT_INVALID_MSG);
      } else {
        tmp_uid.setCustomValidity("");
      }
      var rent_contact_name = document.getElementById("rent_contact_name");
      if (this.$commonFuction.isEmpty(this.obj_data.rent_contact_name)) {
        rent_contact_name.setCustomValidity(
            this.$constants.MSG_TEXT.INPUT_INVALID_MSG
        );
      } else {
        rent_contact_name.setCustomValidity("");
      }
      var rent_contact_phone = document.getElementById("rent_contact_phone");
      var txt_phone = "";
      if (this.$commonFuction.isEmpty(this.obj_data.rent_contact_phone)) {
        txt_phone = this.$constants.MSG_TEXT.INPUT_INVALID_MSG;
        //rent_contact_phone.setCustomValidity(this.$constants.MSG_TEXT.INPUT_INVALID_MSG);
      } else {
        if (this.obj_data.rent_contact_phone.length < 8) {
          txt_phone = "Please enter a phone number of at least 8 characters!";
          //phone.setCustomValidity("Please enter a phone number of at least 8 characters!");
        } else {
          if (
              !this.$commonFuction.validatePhoneNumber(
                  this.obj_data.rent_contact_phone
              )
          ) {
            txt_phone = "Invalid phone number";
          }
          //kiểm tra
          //phone.setCustomValidity("");
        }
      }
      if (!this.$commonFuction.isEmpty(txt_phone)) {
        rent_contact_phone.setCustomValidity(txt_phone);
      } else {
        rent_contact_phone.setCustomValidity("");
      }

      var rent_contact_email = document.getElementById("rent_contact_email");
      if (this.$commonFuction.isEmpty(this.obj_data.rent_contact_email)) {
        rent_contact_email.setCustomValidity(
            this.$constants.MSG_TEXT.INPUT_INVALID_MSG
        );
      } else {
        if (
            await this.$commonFuction.IsEmail(this.obj_data.rent_contact_email)
        ) {
          rent_contact_email.setCustomValidity("");
        } else {
          rent_contact_email.setCustomValidity(
              "Email is not in correct format!"
          );
        }
      }
      var tmp_rent_identification_information = document.getElementById(
          "tmp_rent_identification_information"
      );
      if (
          this.$commonFuction.isEmpty(
              this.obj_data.rent_identification_information
          )
      ) {
        tmp_rent_identification_information.setCustomValidity(
            this.$constants.MSG_TEXT.SELECT_INVALID_MSG
        );
      } else {
        tmp_rent_identification_information.setCustomValidity("");
      }
      var rent_number_id = document.getElementById("rent_number_id");
      if (this.$commonFuction.isEmpty(this.obj_data.rent_number_id)) {
        rent_number_id.setCustomValidity(
            this.$constants.MSG_TEXT.INPUT_INVALID_MSG
        );
      } else {
        rent_number_id.setCustomValidity("");
      }
      var rent_pay_price_per_week = document.getElementById(
          "rent_pay_price_per_week"
      );
      if (this.$commonFuction.isEmpty(this.obj_data.rent_pay_price_per_week)) {
        rent_pay_price_per_week.setCustomValidity(
            this.$constants.MSG_TEXT.INPUT_INVALID_MSG
        );
      } else {
        //check nhập số lớn hơn hoặc bằng 0
        if (this.obj_data.rent_pay_price_per_week < 0) {
          rent_pay_price_per_week.setCustomValidity(
              this.$constants.MSG_TEXT.INT_MIN_VALIDATE
          );
        } else {
          rent_pay_price_per_week.setCustomValidity("");
        }
      }
      var rent_pay_bond_fee = document.getElementById("rent_pay_bond_fee");
      if (this.$commonFuction.isEmpty(this.obj_data.rent_pay_bond_fee)) {
        rent_pay_bond_fee.setCustomValidity(
            this.$constants.MSG_TEXT.INPUT_INVALID_MSG
        );
      } else {
        if (this.obj_data.rent_pay_bond_fee < 0) {
          rent_pay_bond_fee.setCustomValidity(
              this.$constants.MSG_TEXT.INT_MIN_VALIDATE
          );
        } else {
          rent_pay_bond_fee.setCustomValidity("");
        }
      }
      var rent_late_fee_threshold = document.getElementById(
          "rent_late_fee_threshold"
      );
      if (this.$commonFuction.isEmpty(this.obj_data.rent_late_fee_threshold)) {
        rent_late_fee_threshold.setCustomValidity(
            this.$constants.MSG_TEXT.INPUT_INVALID_MSG
        );
      } else {
        if (this.obj_data.rent_late_fee_threshold < 0) {
          rent_late_fee_threshold.setCustomValidity(
              this.$constants.MSG_TEXT.INT_MIN_VALIDATE
          );
        } else {
          rent_late_fee_threshold.setCustomValidity("");
        }
      }
      var rent_late_fee_per_day = document.getElementById(
          "rent_late_fee_per_day"
      );
      if (this.$commonFuction.isEmpty(this.obj_data.rent_late_fee_per_day)) {
        rent_late_fee_per_day.setCustomValidity(
            this.$constants.MSG_TEXT.INPUT_INVALID_MSG
        );
      } else {
        if (this.obj_data.rent_late_fee_per_day < 0) {
          rent_late_fee_per_day.setCustomValidity(
              this.$constants.MSG_TEXT.INT_MIN_VALIDATE
          );
        } else {
          rent_late_fee_per_day.setCustomValidity("");
        }
      }

      var rent_booking_fee = document.getElementById("rent_booking_fee");
      if (this.$commonFuction.isEmpty(this.obj_data.rent_booking_fee)) {
        rent_booking_fee.setCustomValidity(
            this.$constants.MSG_TEXT.INPUT_INVALID_MSG
        );
      } else {
        if (this.obj_data.rent_booking_fee < 0) {
          rent_booking_fee.setCustomValidity(
              this.$constants.MSG_TEXT.INT_MIN_VALIDATE
          );
        } else {
          rent_booking_fee.setCustomValidity("");
        }
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        console.log("test=====================");
        inpObj.reportValidity();
        return true;
      }
    },
    async checkEmail(email) {
      // if(this.email !== null && this.email !== ''){
      var where = {
        email: {_eq: email},
        deleted: {_eq: false},
        // type: {'_eq' : 'user'}
      };
      if (this.model !== undefined)
        where = Object.assign(where, {id: {_neq: this.model.id}});
      var {data} = await this.$apollo.query({
        query: DataServices.getList("users", {fields: "id, email"}),
        variables: {
          where_key: where,
        },
        fetchPolicy: "network-only",
      });
      // console.log(data)
      return data && data[Object.keys(data)].length > 0;
      //}
    },
    async saveData(type_action=null) {

      if(type_action == this.$constants.TYPE_ACTION.COMPLETED_PAYMENT){
        if (!confirm("Are you sure you want to complete this order?")) {
            return;
        }
      }else if(type_action == this.$constants.TYPE_ACTION.PAYMENT_REQUEST){
        if (!confirm("Are you sure you want to create a payment request?")) {
            return;
        }
      }
      // this.$commonFuction.is_loading(true);
      // if (await this.validateData()) {
      //   this.$commonFuction.is_loading(false);
      //   return;
      // }
      //console.log("this.from_to", this.from_to);
      //console.log("partArr", this.dataBookingRound);
      var params = this.obj_data;
      //params["list_product"] = this.listDataProduct

       params["type_action"] =type_action
      params["data_other_cost"] =this.listDataOtherCost
      params["id"] =this.obj_data.id
      // params["list_id_file_delete"] = this.list_id_file_delete;
      // params["list_file"] = this.list_file;
      // params["list_file_after"] = this.list_file_after;
      // params["list_id_file_delete_after"] = this.list_id_file_delete_after;
      //params["list_user_family"] = this.listDataUserFamily
      console.log("saveData", params);
      this.$emit("save", params);
    },
  }
};
</script>

<style lang="scss">
.p-multiselect {
  width: 450px;
}

.p-multiselect-label:not(.p-placeholder) {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.category-item-value {
  padding: 0.25rem 0.5rem;
  border-radius: 3px;
  display: inline-flex;
  margin-right: 0.2rem;
  background-color: var(--primary-color);
  color: var(--primary-color-text);
}

.p-multiselect-label-container {
  height: 40px;
}

.p-inputtext {
  margin: 0px 0px 0px 4px;
}

//style form add-edit
@media screen and (min-width: 1001px) {
  .input_distance {
    width: 728px !important;
  }
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.p-col-fixed {
  padding: 0px !important;
  margin: 0px 0px 0px 9px !important;
}

.input_text {
  width: 760px !important;
  height: 48px !important;
}

.multiselect {
  width: 760px !important;
}



.vs__clear {
  display: none;
}

.input_width {
  width: 760px !important;
  height: 48px !important;
}

#distance {
  width: 1px !important;
  height: 48px !important;
  border-left: 0px;
  border-top: 0px;
  border: 1px solid #c8c8c8;
  border-radius: 0px;
  //border-top: none!important;
  //border: 1px solid rgba(60, 60, 60, 0.26);;
}

.manager-title {
  font-size: 24px !important;
}

.input-dif {
  margin-left: 5px !important;
  border-top: 0px;
}

.p-inputgroup-addon {
  height: 48px;
}

.p-col-fixed {
  padding: 0px !important;
  //margin:0px 0px 0px 10px !important;
}

label.p-col-fixed txt-right {
  margin-bottom: 0px !important;
}

div.p-card-field {
  padding: 0px !important;
}

.margin {
  margin-bottom: 12px !important;
}

.border_color {
  border: 1px solid #c8c8c8;
}

.text {
  font-weight: normal !important;
  margin-left: 15px !important;
}

.div_check {
  margin-top: 12px !important;
}

//responsive
@media screen and (max-width: 600px) {
  .input_width {
    width: 100% !important;
  }
  .div-button {
    padding: 8px !important;
  }
  #distance {
    text-align: left !important;
    padding: 6.8px;
    width: 100% !important;
  }
  .p-inputgroup-addon {
    margin-right: 12px;
  }
}

@media screen and (max-width: 1000px) {
  .input_width {
    width: 100% !important;
  }
  .div-button {
    padding: 8px !important;
  }
  .p-inputgroup-addon {
    margin-right: 12px;
  }
  #distance {
    text-align: left !important;
    padding: 6.8px;
  }
}

/*.p-button-outlined {
  .p-button-label {
    color: #007ad9 !important;
  }
}*/
.cus-text {
  margin-left: 2px;
  margin-top: 4px;
}

.style-box-phone {
  border: 1px solid #a6a6a6;
  width: 100%;
  display: flex;

  .p-dropdown {
    width: 100px;
    border: 0px;
    box-shadow: none !important;
  }

  .p-focus {
    border: 0px;
    box-shadow: none;
  }

  .p-dropdown:focus {
    border: 0px;
    box-shadow: none;
  }

  input {
    width: calc(100% - 100px);
    margin-left: 0px;
    border: 0px;
  }

  .p-inputtext:enabled:focus {
    border: 0px;
    box-shadow: none;
  }
}

.style_list_image {
  display: flex;
  flex-wrap: wrap; /* Cho phép các phần tử xuống dòng */
  gap: 10px; /* Khoảng cách giữa các phần tử */
  .box-image {
    width: 100px;
    height: 100px;
    margin-top: 8px;
    margin-bottom: 8px;
    position: relative;

    .style_img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border: 1px solid #d0d4d9;
      border-radius: 10px;
    }

    .button-clear {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 1px;
      right: 8px;
    }
  }
}

.box-password-style {
  width: 100%;
  position: relative;

  .lg-icon-password {
    margin-top: -30px;
    display: block;
    position: absolute;
    right: 10px;
    padding: auto 5px;

    &:hover {
      cursor: pointer;
    }
  }
}

.style_title_group {
  font: normal normal bold 20px/27px Segoe UI;
  letter-spacing: 0px;
  color: #333333;
  text-transform: uppercase;
  margin-bottom: 8px;
  margin-top: 8px;
}

.gender-options {
  display: flex; // Sử dụng flexbox để căn chỉnh ngang
  gap: 48px; // Khoảng cách giữa các radio button

  label {
    display: flex;
    align-items: center; // Căn giữa theo chiều dọc
    cursor: pointer; // Hiển thị con trỏ khi hover

    input[type="radio"] {
      width: 20px; // Chiều rộng
      height: 20px; // Chiều cao
      margin-right: 5px; // Khoảng cách giữa radio button và nhãn
    }
  }
}

.style_line_password {
  text-align: left;
  font: normal normal normal 16px/21px Segoe UI;
  letter-spacing: 0px;
  color: #666666;
}

.group-button-detail-top {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 16px;
  padding-right: 0px;

  .style-button-common {
    margin-left: 8px;
    margin-right: 8px;
    width: fit-content;
  }

  .style-button-common:last-of-type {
    margin-right: 0px;
  }
}

.clear_icon_select {
  .vs__clear {
    display: unset !important;
  }
}

.popup-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  .box-left {
    padding-left: 0px;
    padding-right: 8px;
  }

  .box-right {
    padding-left: 8px;
    padding-right: 0px;
  }
}

.popup-title {
  font: normal normal normal 16px/19px Segoe UI;
  letter-spacing: 0px;
  color: #666666;
}

.popup-money {
  font: normal normal normal 16px/19px Segoe UI;
  color: #000000;
}

.form-group-popup {
  margin-bottom: 15px;
  width: 100%;

  label {
    display: block;
    text-align: left;
    margin-bottom: 5px;
    font-weight: bold;
  }

  // input {
  //   margin-left: 0px;
  //   width: 100%;
  //   padding: 8px;
  //   // margin-top: 5px;
  // }
}

.popup_select_car_for_rent {
  .vs__dropdown-toggle {
    height: 40px;
  }

  #text-field-container {
    margin-top: -10px;
  }
}

.car_custom_popup {
  margin-top: -18px;
}

.box-payment {
  background: #F8F8F8 0% 0% no-repeat padding-box;
  border: 1px solid #D0D4D9;
  border-radius: 5px;
  padding: 20px; /* Thêm khoảng cách cho nội dung */

  .payment-item {
    display: flex;
    justify-content: space-between; /* Đẩy title sang trái và price sang phải */
    align-items: flex-start; /* Căn chỉnh theo chiều dọc */
  }

  .title {
    font: normal normal normal 16px/19px Segoe UI;
    letter-spacing: 0px;
    color: #666666;
    word-wrap: break-word; /* Cho phép title bọc dòng nếu nội dung quá dài */
  }

  .price {
    white-space: nowrap; /* Ngăn giá tiền xuống dòng */
    font: normal normal normal 16px/19px Segoe UI;
    letter-spacing: 0px;
    color: #000000;
  }
}

.line_horizontal {
  border: 1px solid #f1f0f0;
  margin-bottom: 10px;
  margin-top: 10px;
}

.style-box-payment {
  margin-left: 9px;
  margin-right: 9px;
  margin-top: 8px;
  margin-bottom: 8px
}


</style>
